import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function YearlySalesHeader() { return ( <ContentHeader title='Yearly Sales Report' /> ) }

export default React.memo(YearlySalesHeader)
